import { Box } from "@mui/material";
import { useEffect, useRef, useState, type RefObject } from "react";
import {
  CompactPeriodControl,
  type CompactPeriodControlProps,
} from "./CompactPeriodControl";
import { useFlipFromElement } from "src-next/modules/clinical-insights/helpers/useFlipFromElement";

export const FRAME_PERIOD_SLOT_MIN_HEIGHT = 44;

interface FrameAnimatedPeriodControlProps {
  visible: boolean;
  fromRef: RefObject<HTMLElement | null>;
  compactProps: CompactPeriodControlProps;
}

export function FrameAnimatedPeriodControl({
  visible,
  fromRef,
  compactProps,
}: FrameAnimatedPeriodControlProps) {
  const toRef = useRef<HTMLDivElement>(null);
  const [mounted, setMounted] = useState(visible);

  useEffect(() => {
    if (visible) setMounted(true);
    else setMounted(false);
  }, [visible]);

  useFlipFromElement(fromRef, toRef, visible);

  return (
    <Box
      sx={{
        minHeight: FRAME_PERIOD_SLOT_MIN_HEIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      {mounted ? <CompactPeriodControl ref={toRef} {...compactProps} /> : null}
    </Box>
  );
}
